import { module } from 'modujs';
import modularLoad from 'modularload';
import { lazyLoadImage } from '../utils/image'
import { ScrollTrigger } from '../gsap'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.scrollTo(0, 0)

        const load = new modularLoad({
            enterDelay: 300,
            transitions: {
                customTransition: {}
            }
        });

        this.loadImages()

        load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');
            window.scrollTo(0, 0)
        });

        load.on('loading', (transition, oldContainer) => {
            this.call('close', null, 'Header');
        });

        load.on('ready', () => {
            this.loadImages()
            ScrollTrigger.refresh()
        })
    }

    loadImages() {
        const $lazyImages = document.querySelectorAll('img[data-src]')

        $lazyImages.forEach($img => {
            lazyLoadImage($img)
        })
    }
}
